import React from 'react';
import { TableCell, TableFooter as MaterialTableFooter, TableRow, withStyles } from '@material-ui/core';
import clsx from 'clsx'

const styles = theme => ({
    row: {
        height: '30px',
    },
    cell: {
        padding: '0 !important',
        textAlign: 'center',
        position: "sticky",
        bottom: "0",
        backgroundColor: '#ffffff',
        borderTop: '1px solid rgba(224, 224, 224, 1)',
        borderBottom: 'none'
    },
    cellTitleWrapper: {
        float: 'right',
        margin: '0 3px'
    },
    sideBorders: {
        borderRight: '1px solid rgba(224, 224, 224, 1)'
    },
    visibility: {
        cursor: 'pointer'
    }
});

function TableFooter(props) {

    const { classes, nbColDataview, contentData, fixed, position } = props;
    const generateRow = (content, auxTop, index) => {
        const customTop = {
            bottom: (auxTop * 30) + 'px',
        }

        let { title, data, titleClass } = content;
        let tableRowContent = "";
        let tableCellsTitle = (<React.Fragment>
            {
                nbColDataview > 0 ?
                    <TableCell style={customTop} className={classes.cell} colSpan={nbColDataview} key={title + "-span"}></TableCell> : ""
            }
            <TableCell style={customTop} className={clsx(classes.cell, classes.sideBorders)} key={title + "-title"}>
                {/* <FontAwesomeIcon icon={ visibility ? faEye: faEyeSlash} size="s" className={classes.visibility} onClick={(e) => {onClickVisibility(e, title)}}/> */}
                {/* {visibility === false ? <FontAwesomeIcon icon={faEyeSlash} size="s" className={classes.visibility} onClick={(e) => {onClickVisibility(e, title)}}/> : ""} */}
                <div className={clsx(classes.cellTitleWrapper, titleClass)}>{title}</div>
            </TableCell>
        </React.Fragment>)
        if (fixed) {
            if (position === 'left') {
                tableRowContent = tableCellsTitle;
            }
            // else{
            //     return (
            //     <TableRow className={classes.row}>
            //         <TableCell style={customTop} className={classes.cell} colSpan={ 4} key={title + "-span"}></TableCell>
            //     </TableRow>);
            // }
        }
        else {
            let tableCellsData = []
            for (let [index, value] of data.entries()) {
                tableCellsData.push(<TableCell key={index} style={customTop} className={clsx(classes.cell, classes.sideBorders)}>{value}</TableCell>) 
            }

            tableRowContent = (<React.Fragment>
                {tableCellsTitle}
                {tableCellsData}
                {/* <TableCell style={customTop} className={classes.cell} colSpan={ 4} key={title + "-span"}></TableCell> */}
            </React.Fragment>);
        }

        return (<TableRow key={index} className={classes.row}>
            {tableRowContent}
        </TableRow>)
    };

    const generateContent = () => {
        let rows = [];
        let auxTop = contentData.length > 0 ? contentData.length - 1 : 0
        contentData.forEach((content, index) => {
            rows.push(generateRow(content, auxTop, index))
            auxTop --
        })
        return rows;
    }

    let content = (
        <MaterialTableFooter key={1000}>
            {generateContent()}
        </MaterialTableFooter>
    )
    // content = !props.showFooter && !props.showRight ? '' : content;
    return content;
}

export default (withStyles(styles)(TableFooter));